import {
  SUCCESS_API_GET_GROUPS,
  SUCCESS_API_GET_GROUP,
  GROUP_SUCCESS_API_GET_OPERATORS,
  SUCCESS_API_UPDATE_GROUP,
  SUCCESS_API_GET_COMPANY_TAGS,
  SUCCESS_API_CREATE_GROUP,
} from '../actions/actionTypes';

export const appInitialState = {
  groups: [],
  operators: [],
  refreshPage: false,
  searchOptions: { name: '', isUsable: true },
  groupDetail: null,
  companyAssociatedTags: [],
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case SUCCESS_API_GET_GROUPS: {
      const { groups = [] } = action.payload;
      const newGroups = groups.map(group => {
        const { address } = group;
        const {
          state: prefecture,
          city,
          address_1: address1,
          address_2: address2,
        } = address;
        const joinArray = [prefecture, city, address1, address2];
        const joinedAddress = joinArray.join(' ');
        return { ...group, joinedAddress };
      });
      return { ...state, groups: newGroups };
    }
    case 'RESET_GROUP_SEARCH_OPTIONS': {
      return { ...state, searchOptions: appInitialState.searchOptions };
    }
    case 'UPDATE_GROUP_SEARCH_OPTIONS': {
      const { param } = action;
      const refreshPage = !state.refreshPage;
      return {
        ...state,
        searchOptions: { ...state.searchOptions, ...param },
        refreshPage,
      };
    }
    case SUCCESS_API_GET_GROUP: {
      return {
        ...state,
        groupDetail: action.payload,
      };
    }
    case GROUP_SUCCESS_API_GET_OPERATORS: {
      const newOperators = action.payload.operators.map(operator => ({
        guid: operator.operatorGuid,
        name: operator.name,
        role: operator.role,
      }));
      return {
        ...state,
        operators: newOperators,
      };
    }
    case SUCCESS_API_UPDATE_GROUP: {
      return {
        ...state,
        refreshPage: !state.refreshPage,
      };
    }
    case SUCCESS_API_GET_COMPANY_TAGS: {
      const companyAssociatedTags =
        action.payload.length > 0 ? action.payload[0].data : [];
      return {
        ...state,
        companyAssociatedTags,
      };
    }
    case SUCCESS_API_CREATE_GROUP: {
      return {
        ...state,
        refreshPage: !state.refreshPage,
      };
    }
    default:
      return state;
  }
};
